<!-- src/views/pages/recruitment/jobs/job-table.vue -->
<script>
import { computed } from "vue";
import { useJobStore } from "@/stores/jobStore";

const columns = [
  {
    sorter: false,
  },
  {
    title: "Job ID",
    dataIndex: "job_code",
    key: "job_code",
    sorter: {
      compare: (a, b) => {
        const x = (a.job_code || "").toLowerCase();
        const y = (b.job_code || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "Job Title",
    dataIndex: "title",
    key: "title",
    sorter: {
      compare: (a, b) => {
        const x = (a.title || "").toLowerCase();
        const y = (b.title || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: {
      compare: (a, b) => {
        const x = (a.category || "").toLowerCase();
        const y = (b.category || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "Location",
    dataIndex: "location_label",
    sorter: {
      compare: (a, b) => {
        const x = (a.location_label || "").toLowerCase();
        const y = (b.location_label || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "Salary  Range",
    dataIndex: "salary_range_label",
    sorter: {
      compare: (a, b) => {
        const x = (a.salary_range_label || "").toLowerCase();
        const y = (b.salary_range_label || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "Posted Date",
    dataIndex: "posted_date_label",
    sorter: {
      compare: (a, b) => {
        const x = (a.posted_date_label || "").toLowerCase();
        const y = (b.posted_date_label || "").toLowerCase();
        return x > y ? -1 : y > x ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const jobStore = useJobStore();

    const tableData = computed(() => jobStore.items);

    const handleEdit = (record) => {
      jobStore.openEdit(record);
    };

    const handleDelete = (record) => {
      jobStore.destroy(record.id);
    };

    return {
      columns,
      rowSelection,
      tableData,
      handleEdit,
      handleDelete,
    };
  },
};
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="tableData"
    :row-selection="rowSelection"
    :loading="loading"
    row-key="id"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'title'">
        <div class="d-flex align-items-center file-name-icon">
          <a href="javascript:void(0);" class="avatar avatar-md bg-light rounded">
            <img
              :src="
                record.logo
                  ? record.logo
                  : require(`@/assets/img/icons/apple.svg`)
              "
              class="img-fluid rounded-circle"
              alt="img"
            />
          </a>
          <div class="ms-2">
            <h6 class="fw-medium">
              <a href="javascript:void(0);">{{ record.title }}</a>
            </h6>
            <span class="d-block mt-1">
              {{ record.applicants_count }} Applicants
            </span>
          </div>
        </div>
      </template>

      <template v-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            href="javascript:void(0);"
            class="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_post"
            @click="handleEdit(record)"
            ><i class="ti ti-edit"></i
          ></a>
          <a
            href="javascript:void(0);"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            @click="handleDelete(record)"
            ><i class="ti ti-trash"></i
          ></a>
        </div>
      </template>
    </template>
  </a-table>
</template>
